import { LiveStatus } from 'src/pages/CommunityDetails/Posts/live'

export type LiveResponse = {
  id: number | string | null
  data: LivePayload[]
  size: number
  page: number
}

export type LivePayload = {
  id: number
  code: string
  name: string
  visibility: string
  description: string
  url: string
  liveStartAt: number
  completed: boolean
  completedAt: number
  zoneId: string
  amountLead: number
  largeThumbnailLink: string
  smallThumbnailLink: string
  status: LiveStatus
  linkLive: string
  link?: string
  managementLink?: string
  reportLink?: string
  enableVodPlayback?: boolean
}

export enum LiveSortParams {
  LIVE_START_AT_DESCENDING = 'LIVE_START_AT_DESCENDING',
  LIVE_START_AT = 'LIVE_START_AT'
}

export type GetWebinarsParams = {
  locale?: string
  status?: LiveStatus
  sort?: LiveSortParams
  rows?: number
  page?: number
}
